import {combineReducers} from 'redux';
// import constants from './config/reducer';
// import ThemeSwitcher from './themeswitcher/reducer';
import mitrotech from './mitrotech/reducer';
import config from './config/reducer';
// import modals from './modal/reducer';

const AllReducers =   combineReducers({
    config:config,
    mitrotech:mitrotech,
    //   ordercart:ordercart,
    //   App:App,
    //   modals:modals
      });

export default AllReducers;

